import React from 'react';
import PieChart from '../../../../Simple/echarts/PieChart/index-beta';
import { toSimpleChartData } from '../dataProcessor';

const MultipleCrossSimplePieChart = ({
  data,
  legendsFilter,
  legendsFilterHandler,
  theme,
  themeTitle,
  fontSize,
  updateChartColors,
  colorPickerColors,
  error,
  chartType,
  chartRef,
  cardType,
}) => {
  const simpleChartData = toSimpleChartData(data);

  return (
    <>
      {theme.colors
    && (
      <PieChart
        data={simpleChartData}
        chartFontSize={fontSize}
        legendsFilter={legendsFilter}
        legendsFilterHandler={legendsFilterHandler}
        theme={theme}
        themeTitle={themeTitle}
        updateChartColors={updateChartColors}
        colors={theme.colors}
        colorPickerColors={colorPickerColors}
        // Os update preventers impedem a criação de uma nova instância do gráfico em algum ponto
        // quando altera o tema selecionado. Para isto foi acrescentado a propriedade "key"
        // para gerar uma nova instância do componente quando o tema mudar
        key={`${themeTitle}`}
        cardType={cardType}
        error={error}
        chartType={chartType}
        chartRef={chartRef}
      />
    )}

    </>
  );
};

export default MultipleCrossSimplePieChart;
